module.exports = __webpack_public_path__ + "img/mobile-wish-outline.64636eb.svg?v=1763034624171";